import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { dollars } from "LIB/formatters/currency";
import { CANCELLATION_REASONS } from "MODULES/PurchaseOrders/constants";
import { properCase } from "LIB/formatters/text";
import { BIO_HAZMAT, HAZMAT } from "MODULES/parts/constants";
import { Warning } from "MODULES/shared/components";
import { Link } from "react-router-dom";

function HazmatWarning({ bio_hazmat: bioHazmat, hazmat }) {
  const warnings = [];
  if (hazmat) {
    warnings.push(properCase(HAZMAT));
  }

  if (bioHazmat) {
    warnings.push(properCase(BIO_HAZMAT));
  }

  if (warnings.length === 0) {
    return false;
  }

  return <Warning>This line item is marked: {warnings.join(", ")}</Warning>;
}

HazmatWarning.propTypes = {
  hazmat: PropTypes.bool,
  bio_hazmat: PropTypes.bool
};

export default function PartSummary({
  part,
  quantity,
  cost,
  lineItem,
  hazmatFee,
  containerFee
}) {
  const calculateCost = (qty, costUnit) => {
    const fees = parseFloat(hazmatFee || 0) + parseFloat(containerFee || 0);
    if (fees > 0) {
      return dollars(parseFloat(qty) * parseFloat(costUnit) + fees) || "$0.00";
    }
    return dollars(parseFloat(qty) * parseFloat(costUnit)) || "$0.00";
  };

  const reason = CANCELLATION_REASONS.find(
    x => x.value === (lineItem && lineItem.cancellation_reason)
  );

  return (
    <div className="well">
      <h6 className="h4">Part Summary</h6>
      <table className="table table-condensed table-padding-horizonal-none margin-bottom-none">
        <tbody>
          <tr>
            <td>Part #{part && part.part_number}</td>
            <td className="text-right">{cost}</td>
          </tr>
          <tr>
            <td colSpan="2">
              <em className="text-muted">{part && part.description}</em>
            </td>
          </tr>
          {lineItem &&
            lineItem.repair_order_line_item && (
              <tr>
                <td>Repair:</td>
                <td className="text-right">
                  <Link
                    to={`/repair-orders/${get(
                      lineItem,
                      "repair_order_line_item.repair_order.uuid"
                    )}`}
                  >
                    {get(lineItem, "repair_order_line_item.repair_order.code")}
                  </Link>
                </td>
              </tr>
            )}
          {hazmatFee && (
            <tr>
              <td>Hazmat Fee: </td>
              <td className="text-right">{parseFloat(hazmatFee).toFixed(2)}</td>
            </tr>
          )}
          {containerFee && (
            <tr>
              <td>Container/Crate Fee: </td>
              <td className="text-right">
                {parseFloat(containerFee).toFixed(2)}
              </td>
            </tr>
          )}
          <tr>
            <td>QTY</td>
            <td className="text-right">{quantity}</td>
          </tr>
          <tr>
            <td colSpan="2">{HazmatWarning(lineItem || {})}</td>
          </tr>
        </tbody>
      </table>
      {lineItem &&
        lineItem.cancelled && (
          <p>
            <br />
            <span style={{ color: "#f44336" }}>Cancellation Reason:</span>{" "}
            {reason.text}
            <br />
          </p>
        )}
      <hr className="hr-xs" />
      <table className="table table-condensed table-padding-horizonal-none">
        <tbody>
          <tr>
            <td>
              <h5 className="h4 margin-top-none margin-bottom-none">Total</h5>
            </td>
            <td className="text-right">
              <h5 className="h4 margin-top-none margin-bottom-none">
                {calculateCost(quantity, cost)}
              </h5>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

PartSummary.propTypes = {
  part: PropTypes.instanceOf(Object),
  quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  cost: PropTypes.string,
  lineItem: PropTypes.instanceOf(Object),
  hazmatFee: PropTypes.string,
  containerFee: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/modules/ManagedRepairOrders/shared/PartSummary.jsx